var Head = /*@__PURE__*/ (function () {
    function Head(element) {
        var _this = this;
        this.updateMonth = function (month, year) {
            _this.month = month;
            _this.year = year;
            _this.render();
        };
        this.render = function () {
            var month = Head.MONTHS[_this.month];
            var year = _this.year;
            var label = month + " " + year;
            jQuery(_this.element).find('[data-label]').html(label);
        };
        this.element = element;
    }
    Head.MONTHS = [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ];
    return Head;
}());
export default Head;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/plugins/DatePicker/Head.ts
// module id = null
// module chunks = 